import React from 'react';
import { FileX, Wrench, Container, CreditCard } from 'lucide-react';

const loanPrograms = [
  {
    name: "NO-TAX-RETURN TRUCK PROGRAM",
    subtext: "Up to $250k for a new or used truck",
    icon: FileX,
  },
  {
    name: "EMERGENCY REPAIR CAPITAL",
    subtext: "Funds to cover major repairs",
    icon: Wrench,
  },
  {
    name: "STEEL BIN PROGRAM",
    subtext: "Financing for roll-off dumpsters",
    icon: Container,
  },
  {
    name: "THE VLOC PROGRAM",
    subtext: "Take equity from paid-off trucks",
    icon: CreditCard,
  }
];

const ServiceFeatures = () => {
  return (
    <section className="relative py-12 overflow-hidden border-t-2 border-b-2 border-[#00A86B]">
      {/* Background */}
      <div 
        className="absolute inset-0 bg-[#0A1628]"
        style={{
          backgroundImage: `repeating-linear-gradient(
            -45deg,
            transparent,
            transparent 10px,
            rgba(0,168,107,0.05) 10px,
            rgba(0,168,107,0.05) 20px
          )`
        }}
      ></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title - 25% larger */}
        <div className="text-center mb-10">
          <h3 className="text-3xl md:text-4xl font-black text-white tracking-wider uppercase">
            LOAN PROGRAMS
          </h3>
        </div>
        
        {/* Programs Row - Grid layout for mobile, row for desktop */}
        <div className="grid grid-cols-2 md:flex md:justify-center md:items-start gap-6 md:gap-10 lg:gap-20 xl:gap-24">
          {loanPrograms.map((program, index) => {
            const IconComponent = program.icon;
            return (
              <div key={index} className="flex flex-col items-center text-center group cursor-pointer">
                {/* Icon above - 25% larger */}
                <div className="w-14 h-14 md:w-[70px] md:h-[70px] border-2 border-[#00A86B] rounded-full flex items-center justify-center mb-3 md:mb-4 group-hover:bg-[#00A86B]/20 transition-colors">
                  <IconComponent className="w-7 h-7 md:w-9 md:h-9 text-[#00A86B]" strokeWidth={1.5} />
                </div>
                {/* Program name */}
                <span className="text-white font-bold text-xs md:text-base lg:text-lg uppercase group-hover:text-[#00A86B] transition-colors max-w-[140px] md:max-w-[175px]">
                  {program.name}
                </span>
                {/* Subtext */}
                <span className="text-gray-400 text-xs mt-1 md:mt-2 max-w-[140px] md:max-w-[175px]">
                  {program.subtext}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceFeatures;
